<form *ngIf="fields && addEditForm" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate()" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.sales_network_id.nullable}">{{ fields.sales_network_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown [options]="salesNetworkList" formControlName="sales_network_id" [style]="{ width: '100%' }"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.sales_network_id"></app-validation-msg>
      </div>
    </div>
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.division_id.nullable}">{{ fields.division_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-dropdown [options]="divisionList" formControlName="division_id" [style]="{ width: '100%' }"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.division_id"></app-validation-msg>
      </div>
    </div>

  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{this.divisionSalesNetworkId !== 0 ? ('common.edit' | translate) : ('common.add' | translate) }} {{ 'division_sales_network.division_sales_network' |translate }}"></button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/division-sales-network/division-sales-network-form.component.html